/**
 * Centralized image configuration
 * This file contains all image paths used throughout the application
 * Making it easy to update image references in one place
 */

export const IMAGES = {
  // Portrait images
  CHRIS_PORTRAIT: '/assets/images/chris-plaschy-portrait.jpg',
  
  // Blog images (placeholder paths - add actual images when available)
  BLOG_SYSTEMATIC_ACCOUNTING: '/assets/images/blog/systematische-buchhaltung-ocpd.jpg',
  BLOG_PROCESS_DIAGRAM: '/assets/images/blog/buchhaltungsprozess-diagramm.svg',
  
  // Testimonial images
  TESTIMONIAL_REYNALD: '/assets/testemonials/reynald_lhullier.webp',
  
  // Service icons (placeholder paths - add actual images when available)
  SERVICE_ACCOUNTING_ICON: '/assets/icons/service-accounting.svg',
  
  // Hero background (placeholder path - add actual image when available)
  HERO_BACKGROUND: '/assets/images/hero-background.jpg',
  
  // Logo (placeholder path - add actual logo when available)
  LOGO: '/assets/logo.svg',
} as const;

/**
 * Helper function to get image path with fallback
 * @param imageKey - Key from IMAGES object
 * @param fallback - Fallback path if image doesn't exist
 * @returns Image path or fallback
 */
export const getImagePath = (imageKey: keyof typeof IMAGES, fallback?: string): string => {
  return IMAGES[imageKey] || fallback || '/assets/images/placeholder.jpg';
};

/**
 * Helper function to get Chris's portrait image
 * @returns Chris's portrait image path
 */
export const getChrisPortrait = (): string => {
  return IMAGES.CHRIS_PORTRAIT;
};

/**
 * Helper function to get full URL for images (useful for Open Graph)
 * @param imageKey - Key from IMAGES object
 * @param baseUrl - Base URL of the website
 * @returns Full URL for the image
 */
export const getImageUrl = (imageKey: keyof typeof IMAGES, baseUrl: string = 'https://treuhand-beratungen.ch'): string => {
  const imagePath = IMAGES[imageKey];
  return imagePath.startsWith('http') ? imagePath : `${baseUrl}${imagePath}`;
};

/**
 * Helper function to get Chris's portrait URL for social sharing
 * @returns Full URL for Chris's portrait image
 */
export const getChrisPortraitUrl = (): string => {
  return getImageUrl('CHRIS_PORTRAIT');
};
